
<template>
    <Modal
        v-model="isOpen"
        title="IBFG Anfrage"
        class="no-padding-left no-padding-right"
        ref="modal"
        fullscreen
        :toolbar="true"
        keep-footer-on-keyboard-show
    >
        <template v-slot:default>
            <ion-content class="no-padding">
                <ion-item>
                    <ion-label position="stacked">Thema</ion-label>
                    <ion-input v-model="topic" aria-label="Thema"></ion-input>
                </ion-item>
                <ion-item>
                    <ion-label position="stacked">Frage</ion-label>
                    <ion-textarea v-model="question" aria-label="Frage"></ion-textarea>
                </ion-item>
                <ion-item>
                    <ion-label position="stacked">Zusätzliche Informationen</ion-label>
                    <ion-textarea autoGrow v-model="additionalDescription" aria-label="Zusatzinformation"></ion-textarea>
                </ion-item>
            </ion-content>
            <ion-footer>
                <ion-button
                    @click="onSubmit"
                    expand="block"
                    color="primary"
                >
                    Absenden
                </ion-button>
            </ion-footer>
        </template>
    </Modal>
</template>


<script setup lang="ts">

import {IonButton, IonContent, IonFooter, IonInput, IonTextarea, IonLabel, IonItem} from "@ionic/vue"
import {Ref, ref, watch} from "vue"
import Modal from '@/components/Modal.vue'
import {useChatStore} from "@/helper/chat/chatStore";
import {ChatContext, HumanRequest} from "@/graphql/generated/graphql";
import {DataLoader} from "@/helper/dataLoader";
import {fetchHumanRequestSuggestions} from "@/helper/chat/humanRequests";

const emit = defineEmits(['submit'])

const modelValue: Ref<boolean> = defineModel()
const isOpen:  Ref<boolean> = ref(modelValue.value)
const modal = ref()

const topic = ref<string|undefined>("")
const question = ref<string|undefined>("")
const additionalDescription = ref<string|undefined>("")



watch(()=>modelValue.value, value =>isOpen.value=value)
watch(() => isOpen.value, value => modelValue.value = value)


const loader = new DataLoader(
    async () => {

        const chatStore = useChatStore()

        const chatContext: ChatContext = {
            runId: chatStore.currentExpertRun?.getRunId(),
            threadId: chatStore.currentExpertRun?.runConfig.threadId,
            assistantId: chatStore.currentExpertRun?.runConfig.assistantId,
            assistantType: chatStore.currentExpertRun?.runConfig.assistantType,
            sessionId: useChatStore().sessionId,
            pipoId: useChatStore().pingPongId,
        }

        const humanRequestSuggestions = await fetchHumanRequestSuggestions(chatContext)
        if(humanRequestSuggestions){
            topic.value = humanRequestSuggestions.topic || ""
            question.value = humanRequestSuggestions.question || ""
            additionalDescription.value = humanRequestSuggestions.additionalDescription || ""
        }

    }
)

loader.load()

const onSubmit = async () => {
    const chatStore = useChatStore()

    const chatContext: ChatContext = {
        runId: chatStore.currentExpertRun?.getRunId(),
        threadId: chatStore.currentExpertRun?.runConfig.threadId,
        assistantId: chatStore.currentExpertRun?.runConfig.assistantId,
        assistantType: chatStore.currentExpertRun?.runConfig.assistantType,
        sessionId: useChatStore().sessionId,
        pipoId: useChatStore().pingPongId,
    }

    const entity: HumanRequest = {
        topic: topic.value,
        question: question.value,
        additionalDescription: additionalDescription.value,
        chatContext: chatContext
    }

    modal.value.dismiss().then(()=>{emit('submit', entity)})
}

</script>

